import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { useIsMobile } from "src/latest/src/hooks";

interface PaginationProps {
  activePage: number;
  totalNoOfPages: number;
  onPageChange: (page: number) => void;
}

export default function PaginationController(props: PaginationProps) {
  const isMobile = useIsMobile();
  const paginationProp = { ...props };
  
  const handleChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    props.onPageChange(newPage - 1);
  };

  return (
    <Stack spacing={2}>
      <Pagination
        count={paginationProp?.totalNoOfPages}
        page={paginationProp?.activePage + 1}
        onChange={handleChange}
        size={isMobile ? "small" : "medium"}
      />
    </Stack>
  );
}
